var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      ref: "chartWrapper",
      staticStyle: {
        width: "100%",
        position: "relative",
        "overflow-x": "hidden",
      },
    },
    [_c("div", { ref: "chart" })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }